import { SET_CUSTOMIZATION, SET_LOGO_URL, SET_SMALL_LOGO_URL } from "../actions/types";

const initialState = {};

function initCustomization(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_CUSTOMIZATION:
      return { ...payload };
    case SET_LOGO_URL:
      return { ...state, logo_url: payload };
    case SET_SMALL_LOGO_URL:
      return { ...state, small_logo_url: payload };
    default:
      return state;
  }
}

export default initCustomization;
